import React, { useEffect, useState } from 'react';

import './faqArticle.scss';
import GuestLayout from '../layouts/GuestLayout';

import articles from './articles';
import _MD from 'markdown-it';
import { Link } from '../hooks/router';
const MD = _MD({
  breaks: true,
  linkify: true,
  typographer: true
});


export default function FaqArticle({ route }) {
  const [article, setArticle] = useState(null);

  useEffect(() => {
    setArticle(articles.find(art => art.slug === route.params.slug));
  }, [route]);

  if (!article) {
    return (
      <div className="faq-article-page">
        <div className="head">
          <div className="title">
            <span className="prefix">FAQ / </span>Chargement
          </div>
        </div>
        <div className="article">
          <div style={{ padding: '20px', borderTop: '1px solid #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="loader">
              <svg height="100%" viewBox="0 0 32 32" width="100%">
                <circle cx="16" cy="16" fill="none" r="14" strokeWidth="4" style={{ stroke: '#fdd002', opacity: '0.2' }} />
                <circle cx="16" cy="16" fill="none" r="14" strokeWidth="4" style={{ stroke: '#fdd002', strokeDasharray: '80px', strokeDashoffset: '60px' }} />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="faq-article-page">
      <div className="head">
        <div className="title">
          <span className="prefix">FAQ / </span>{article.title}
        </div>
      </div>
      <div className="actions">
        <Link to="faq" className="back-link"><i className="fas fa-arrow-left" /> Retourner aux articles</Link>
      </div>
      <div className="article" dangerouslySetInnerHTML={{ __html: MD.render(article.text) }} />
    </div>
  );
};
